/** "3 min ago" for a recent time, a date for an old one. */
export function ago(iso: string | null, now = Date.now()): string {
  if (!iso) return 'Never';
  const s = Math.max(0, Math.round((now - Date.parse(iso)) / 1000));
  if (s < 45) return 'Just now';
  const m = Math.round(s / 60);
  if (m < 60) return `${m} min ago`;
  const h = Math.round(m / 60);
  if (h < 24) return `${h} h ago`;
  const d = Math.round(h / 24);
  return d < 14 ? `${d} d ago` : new Date(iso).toLocaleDateString();
}

export const fullTime = (iso: string) => new Date(iso).toLocaleString();

/** "2.4 MB", "310 KB". */
export function formatBytes(n: number): string {
  if (n < 1024) return `${n} bytes`;
  if (n < 1024 * 1024) return `${Math.round(n / 1024)} KB`;
  return `${(n / 1024 / 1024).toFixed(1)} MB`;
}

/** The next version number after "1.2" is "1.3"; anything else is left for the person to type. */
export function nextVersion(current: string): string {
  const m = /^(\d+)\.(\d+)$/.exec(current.trim());
  return m ? `${m[1]}.${Number(m[2]) + 1}` : '';
}
